import "./DeleteConfirmationDialog.scss";

import { ImageWithFallbacks } from "./ImageWithFallbacks";
import * as React from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import type { ImageSources } from "../../model/ArticleTypes";
import { getUrls } from "../cart-page/ArticleBadgeImage";
import { TrackedButton } from "./TrackedComponents";
type DeleteConfirmationDialogProps = {
	show: boolean;
	onCancel: () => void;
	onDelete: () => void;
	items?: DeleteItemView[] | null;
};
export type DeleteItemView = {
	bundleId: string;
	description: string | null | undefined;
	imageSources: ImageSources;
};
type ExtendedDeleteConfirmationDialogProps = {
	titleKey: string;
	bodyKey: string;
	cancelBtnKey: string;
	confirmBtnKey: string;
} & DeleteConfirmationDialogProps;
export class DeleteConfirmationDialog extends React.Component<ExtendedDeleteConfirmationDialogProps> {
	_handleDialogKeyDown(event: React.KeyboardEvent): void {
		switch (event.key) {
			case "Enter":
				this.props.onDelete();
				break;
			case "Escape":
				this.props.onCancel();
				break;
			default:
				return;
		}

		event.preventDefault();
	}

	_renderArticleImage(articleData: DeleteItemView | null | undefined) {
		return articleData ? (
			<div className="mfcss_card-article-2--image">
				<div className="test-delete-confirmation-dialog-article-image">
					<ImageWithFallbacks urls={getUrls(articleData)} />
				</div>
			</div>
		) : null;
	}

	_renderItemList(itemBatchData: DeleteItemView[]) {
		return (
			<ul className="oc-delete-dialog-item-list margin-grid-top">
				{itemBatchData.map((itemData) => (
					<li>
						<div className="text-overflow-ellipsis">{itemData.description || itemData.bundleId}</div>
					</li>
				))}
			</ul>
		);
	}

	_renderItems(items: DeleteItemView[]) {
		return items.length > 1
			? this._renderItemList(items)
			: items.length === 1
			  ? this._renderArticleImage(items[0])
			  : null;
	}

	render() {
		const items: DeleteItemView[] = this.props.items || [];
		const articleDescription: string | null | undefined =
			items.length === 1 ? items[0].description || items[0].bundleId : null;
		return (
			<Modal
				show={this.props.show}
				data-selenium="delete-dialog"
				className="dialog-delete btoc-delete-dialog test-delete-modal"
				onHide={this.props.onCancel}
				onKeyDown={this._handleDialogKeyDown.bind(this)}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<FormattedMessage id={this.props.titleKey} />
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="delete_item_dialog">
					<span>
						<FormattedMessage
							id={this.props.bodyKey}
							values={{
								articleDescription
							}}
							className="test-delete-confirmation-dialog-body-message"
						/>
					</span>
					<p>{this._renderItems(items)}</p>
				</Modal.Body>
				<Modal.Footer>
					<TrackedButton
						tags={{
							source: "DeleteCartConfirmationDialog.cancel"
						}}
						className="button-dialog button-cancel test-delete-cancel"
						data-selenium="delete-cancel-btn"
						bsStyle="default"
						onClick={this.props.onCancel}
					>
						<FormattedMessage id={this.props.cancelBtnKey} />
					</TrackedButton>
					<TrackedButton
						tags={{
							source: "DeleteCartConfirmationDialog.confirm"
						}}
						className="button-dialog button-save test-delete-confirm"
						data-selenium="delete-confirm-btn"
						autoFocus
						bsStyle="primary"
						onClick={this.props.onDelete}
					>
						<FormattedMessage id={this.props.confirmBtnKey} />
					</TrackedButton>
				</Modal.Footer>
			</Modal>
		);
	}
}
export const DeleteCartConfirmationDialog = (props: DeleteConfirmationDialogProps) => {
	const extendedProps = {
		...props,
		titleKey: "ORC_SHOPPINGCARTPAGE_DELETE_CART_QUESTION",
		bodyKey: "ORC_SHOPPINGCARTPAGE_DELETE_CART_QUESTION_SUBTITLE",
		cancelBtnKey: "ORC_SHOPPINGCARTPAGE_MODAL_BUTTON_CANCEL",
		confirmBtnKey: "ORC_SHOPPINGCARTPAGE_MODAL_BUTTON_YES"
	};
	return <DeleteConfirmationDialog {...extendedProps} />;
};
export const DeleteItemConfirmationDialog = (props: DeleteConfirmationDialogProps) => {
	const extendedProps = {
		...props,
		titleKey: "ORC_SHOPPINGCARTPAGE_DELETE_ITEM_QUESTION_SHORT",
		bodyKey: "ORC_SHOPPINGCARTPAGE_DELETE_ITEM_QUESTION_SUBTITLE_WITH_DESCRIPTION",
		cancelBtnKey: "ORC_SHOPPINGCARTPAGE_MODAL_BUTTON_CANCEL",
		confirmBtnKey: "ORC_SHOPPINGCARTPAGE_MODAL_BUTTON_YES"
	};
	return <DeleteConfirmationDialog {...extendedProps} />;
};
export const DeleteItemsConfirmationDialog = (props: DeleteConfirmationDialogProps) => {
	const extendedProps = {
		...props,
		titleKey: "ORC_SHOPPINGCARTPAGE_DELETE_ITEM_QUESTION_SHORT",
		bodyKey: "ORC_SHOPPINGCARTPAGE_DELETE_ITEMS_WITH_ERRORS_QUESTION_SUBTITLE",
		cancelBtnKey: "ORC_SHOPPINGCARTPAGE_MODAL_BUTTON_CANCEL",
		confirmBtnKey: "ORC_SHOPPINGCARTPAGE_MODAL_BUTTON_YES"
	};
	return <DeleteConfirmationDialog {...extendedProps} />;
};
export const DeleteOrderConfirmationDialog = (props: DeleteConfirmationDialogProps) => {
	const extendedProps = {
		...props,
		titleKey: "ORC_FAILED_SUBMIT_DELETE_QUESTION",
		bodyKey: "ORC_FAILED_SUBMIT_DELETE_QUESTION_SUBTITLE",
		cancelBtnKey: "ORC_SHOPPINGCARTPAGE_MODAL_BUTTON_CANCEL",
		confirmBtnKey: "ORC_SHOPPINGCARTPAGE_MODAL_BUTTON_YES"
	};
	return <DeleteConfirmationDialog {...extendedProps} />;
};
